import React from "react";
import { Container, Typography } from "@mui/material";
import PropTypes from "prop-types";

import ReadMore from "components/ReadMore";
import { useScreen } from "hooks";

import useStyles from "./useStyles";
import LoadingHeader from "./components/LoadingHeader";

const PageHeader = ({ title, description, loading }) => {
  const { isMobile } = useScreen();
  const classes = useStyles();

  if (loading) return <LoadingHeader />;

  return (
    <Container className={classes.head}>
      <Typography className={classes.title} align="center" variant="h1">
        {title}
      </Typography>
      <Typography className={classes.description} align="center" variant="large">
        {isMobile && (
          <div className={classes.contentReadMore}>
            <ReadMore>{description}</ReadMore>
          </div>
        )}
        {!isMobile && description}
      </Typography>
    </Container>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  loading: PropTypes.bool,
};

export default PageHeader;
